import type Feature from 'ol/Feature';
import type Point from 'ol/geom/Point';
import Translate from 'ol/interaction/Translate';
import type VectorLayer from 'ol/layer/Vector';
import type Map from 'ol/Map';
import type VectorSource from 'ol/source/Vector';
import type { AppStore } from '../core/store';
import type { MapTool } from '../core/types';
import { resetLabelPositionOverrides, selectedLogicalLabelIds, setLabelPositionOverride } from '../domain/labelPlacement';

export class LabelPositionController {
  private readonly interaction: Translate;
  private activeLabelId: string | null = null;

  constructor(map: Map, private readonly store: AppStore, layer: VectorLayer<VectorSource<Feature<Point>>>, private readonly status: (text: string) => void) {
    this.interaction = new Translate({ layers: [layer], hitTolerance: 8 }); this.interaction.setActive(false); map.addInteraction(this.interaction);
    this.interaction.on('translatestart', (event) => { this.activeLabelId = String(event.features.item(0)?.get('labelId') ?? '') || null; if (this.activeLabelId) this.status('Arrastra y suelta la etiqueta; la geometría del Maestro no se moverá.'); });
    this.interaction.on('translateend', (event) => {
      const feature = event.features.item(0); const id = String(feature?.get('labelId') ?? ''); const coordinate = (feature?.getGeometry() as Point | undefined)?.getCoordinates();
      if (!id || !coordinate) return;
      const state = this.store.getState(); const labelConfig = setLabelPositionOverride(state.labelConfig, id, [coordinate[0]!, coordinate[1]!]);
      this.activeLabelId = id; this.store.update({ labelConfig }); this.status('Posición manual guardada para esta entidad lógica.');
    });
  }

  setTool(tool: MapTool): void { const active = tool === 'move-labels'; this.interaction.setActive(active); if (active) this.status('Arrastra una etiqueta individual para reposicionarla.'); }

  resetActive(): void {
    const state = this.store.getState(); const selected = selectedLogicalLabelIds(state); const id = this.activeLabelId ?? [...selected][0];
    if (!id) { this.status('Mueve o selecciona una etiqueta para restablecerla.'); return; }
    this.store.update({ labelConfig: resetLabelPositionOverrides(state.labelConfig, new Set([id])) }); this.status('Etiqueta restablecida a su posición automática.');
  }

  resetSelected(): void {
    const state = this.store.getState(); const ids = selectedLogicalLabelIds(state);
    if (!ids.size) { this.status('Selecciona suertes o tablones para restablecer sus etiquetas.'); return; }
    this.store.update({ labelConfig: resetLabelPositionOverrides(state.labelConfig, ids) }); this.status(`${ids.size} etiqueta(s) seleccionadas restablecidas.`);
  }

  resetAll(): void { const state = this.store.getState(); this.store.update({ labelConfig: resetLabelPositionOverrides(state.labelConfig) }); this.activeLabelId = null; this.status('Todas las etiquetas volvieron a posición automática.'); }
}
